import { EventEmitter, Component, Output, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ErrorStateService, AddressBookQuery, AddressBookService, FGBTranslationLoader, FGBMissingTranslationHandler } from '@fgb/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { map } from 'rxjs/operators';
import { ErrorsModule } from '@fgb/portal-component-library/src/lib/shared/errors';
import { LoadingModule } from '@fgb/portal-component-library/src/lib/shared/loading';
import { FormsModule } from '@angular/forms';
import { TranslateModule, TranslateLoader, MissingTranslationHandler } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { ConfirmModalModule } from '@fgb/portal-component-library/src/lib/shared/confirm-modal';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@fgb/core';
import * as ɵngcc2 from '@ng-bootstrap/ng-bootstrap';
import * as ɵngcc3 from '@angular/common';
import * as ɵngcc4 from '@angular/forms';
import * as ɵngcc5 from '@fgb/portal-component-library/src/lib/shared/errors';
import * as ɵngcc6 from '@fgb/portal-component-library/src/lib/shared/confirm-modal';
import * as ɵngcc7 from '@fgb/portal-component-library/src/lib/shared/loading';
import * as ɵngcc8 from '@ngx-translate/core';

function AddressBookComponent_ng_container_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 12);
    ɵngcc0.ɵɵelementStart(2, "table", 4);
    ɵngcc0.ɵɵelementStart(3, "tr");
    ɵngcc0.ɵɵelementStart(4, "td", 13);
    ɵngcc0.ɵɵelementStart(5, "input", 14);
    ɵngcc0.ɵɵlistener("ngModelChange", function AddressBookComponent_ng_container_0_ng_container_1_Template_input_ngModelChange_5_listener($event) { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r8 = ɵngcc0.ɵɵnextContext(2); return ctx_r8.fullName = $event; });
    ɵngcc0.ɵɵpipe(6, "translate");
    ɵngcc0.ɵɵpipe(7, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "td", 13);
    ɵngcc0.ɵɵelementStart(9, "input", 15);
    ɵngcc0.ɵɵlistener("ngModelChange", function AddressBookComponent_ng_container_0_ng_container_1_Template_input_ngModelChange_9_listener($event) { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r10 = ɵngcc0.ɵɵnextContext(2); return ctx_r10.email = $event; });
    ɵngcc0.ɵɵpipe(10, "translate");
    ɵngcc0.ɵɵpipe(11, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(12, "td");
    ɵngcc0.ɵɵelementStart(13, "div", 16);
    ɵngcc0.ɵɵelementStart(14, "button", 17);
    ɵngcc0.ɵɵlistener("click", function AddressBookComponent_ng_container_0_ng_container_1_Template_button_click_14_listener() { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r11 = ɵngcc0.ɵɵnextContext(2); return ctx_r11.addContact(); });
    ɵngcc0.ɵɵtext(15);
    ɵngcc0.ɵɵpipe(16, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(17, "button", 18);
    ɵngcc0.ɵɵlistener("click", function AddressBookComponent_ng_container_0_ng_container_1_Template_button_click_17_listener() { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r12 = ɵngcc0.ɵɵnextContext(2); return ctx_r12.showAddNewForm(); });
    ɵngcc0.ɵɵpipe(18, "translate");
    ɵngcc0.ɵɵelement(19, "span", 19);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(20, "fgbcl-errors");
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵpropertyInterpolate("placeholder", ɵngcc0.ɵɵpipeBind1(6, 9, "address.full.name.screenreader"));
    ɵngcc0.ɵɵproperty("ngModel", ctx_r4.fullName);
    ɵngcc0.ɵɵattribute("aria-label", ɵngcc0.ɵɵpipeBind1(7, 11, "address.full.name.screenreader"));
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵpropertyInterpolate("placeholder", ɵngcc0.ɵɵpipeBind1(10, 13, "address.email.screenreader"));
    ɵngcc0.ɵɵproperty("ngModel", ctx_r4.email);
    ɵngcc0.ɵɵattribute("aria-label", ɵngcc0.ɵɵpipeBind1(11, 15, "address.email.screenreader"));
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("disabled", !ctx_r4.fullName || !ctx_r4.email);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(16, 17, "cl.address.book.add.button"), " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵattribute("aria-label", ɵngcc0.ɵɵpipeBind1(18, 19, "address.close.screenreader"));
} }
function AddressBookComponent_ng_container_0_div_13_Template(rf, ctx) { if (rf & 1) {
    const _r14 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 20);
    ɵngcc0.ɵɵlistener("click", function AddressBookComponent_ng_container_0_div_13_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r14); const ctx_r13 = ɵngcc0.ɵɵnextContext(2); return ctx_r13.showAddNewForm(); });
    ɵngcc0.ɵɵelement(1, "span", 21);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(3, 1, "cl.address.book.add.contact"), " ");
} }
function AddressBookComponent_ng_container_0_tr_15_ng_template_15_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtext(0);
    ɵngcc0.ɵɵpipe(1, "translate");
} if (rf & 2) {
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(1, 1, "cl.address.book.delete.confirm.text"));
} }
function AddressBookComponent_ng_container_0_tr_15_Template(rf, ctx) { if (rf & 1) {
    const _r19 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "tr");
    ɵngcc0.ɵɵelementStart(1, "td", 13);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "td", 13);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "td");
    ɵngcc0.ɵɵelementStart(6, "div", 16);
    ɵngcc0.ɵɵelementStart(7, "button", 22);
    ɵngcc0.ɵɵlistener("click", function AddressBookComponent_ng_container_0_tr_15_Template_button_click_7_listener() { ɵngcc0.ɵɵrestoreView(_r19); const item_r15 = ctx.$implicit; const ctx_r18 = ɵngcc0.ɵɵnextContext(2); return ctx_r18.selectContact(item_r15); });
    ɵngcc0.ɵɵtext(8);
    ɵngcc0.ɵɵpipe(9, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(10, "button", 23);
    ɵngcc0.ɵɵlistener("confirm", function AddressBookComponent_ng_container_0_tr_15_Template_button_confirm_10_listener() { ɵngcc0.ɵɵrestoreView(_r19); const item_r15 = ctx.$implicit; const ctx_r20 = ɵngcc0.ɵɵnextContext(2); return ctx_r20.removeContact(item_r15.Id); });
    ɵngcc0.ɵɵelementStart(11, "label", 24);
    ɵngcc0.ɵɵtext(12);
    ɵngcc0.ɵɵpipe(13, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(14, "span", 25);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(15, AddressBookComponent_ng_container_0_tr_15_ng_template_15_Template, 2, 3, "ng-template", null, 26, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r15 = ctx.$implicit;
    const _r16 = ɵngcc0.ɵɵreference(16);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(item_r15.FullName);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(item_r15.EmailAddress);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(9, 5, "cl.address.book.button.select"), " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("confirmContent", _r16);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(13, 7, "address.remove.contact.screenreader"));
} }
function AddressBookComponent_ng_container_0_div_18_ng_template_23_Template(rf, ctx) { if (rf & 1) {
    const _r28 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 36);
    ɵngcc0.ɵɵelementStart(1, "div", 37);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 38);
    ɵngcc0.ɵɵelementStart(5, "button", 39);
    ɵngcc0.ɵɵlistener("click", function AddressBookComponent_ng_container_0_div_18_ng_template_23_Template_button_click_5_listener() { const modal_r24 = ctx.$implicit; return modal_r24.close("Close click"); });
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵpipe(7, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "button", 40);
    ɵngcc0.ɵɵlistener("click", function AddressBookComponent_ng_container_0_div_18_ng_template_23_Template_button_click_8_listener() { ɵngcc0.ɵɵrestoreView(_r28); const item_r21 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r26 = ɵngcc0.ɵɵnextContext(2); return ctx_r26.removeContact(item_r21.Id); });
    ɵngcc0.ɵɵtext(9);
    ɵngcc0.ɵɵpipe(10, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(3, 3, "cl.address.book.mobile.delete.confirm.text"));
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(7, 5, "cl.address.book.mobile.button.cancel"), " ");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(10, 7, "cl.address.book.mobile.button.confirm"), " ");
} }
function AddressBookComponent_ng_container_0_div_18_Template(rf, ctx) { if (rf & 1) {
    const _r30 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 27);
    ɵngcc0.ɵɵelementStart(1, "div");
    ɵngcc0.ɵɵelementStart(2, "div", 28);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵpipe(4, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 29);
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "div");
    ɵngcc0.ɵɵelementStart(8, "div", 28);
    ɵngcc0.ɵɵtext(9);
    ɵngcc0.ɵɵpipe(10, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(11, "div", 29);
    ɵngcc0.ɵɵtext(12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(13, "div", 30);
    ɵngcc0.ɵɵelementStart(14, "div", 31);
    ɵngcc0.ɵɵelementStart(15, "button", 32);
    ɵngcc0.ɵɵlistener("click", function AddressBookComponent_ng_container_0_div_18_Template_button_click_15_listener() { ɵngcc0.ɵɵrestoreView(_r30); const item_r21 = ctx.$implicit; const ctx_r29 = ɵngcc0.ɵɵnextContext(2); return ctx_r29.selectContact(item_r21); });
    ɵngcc0.ɵɵtext(16);
    ɵngcc0.ɵɵpipe(17, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(18, "button", 33);
    ɵngcc0.ɵɵlistener("click", function AddressBookComponent_ng_container_0_div_18_Template_button_click_18_listener() { ɵngcc0.ɵɵrestoreView(_r30); const _r22 = ɵngcc0.ɵɵreference(24); const ctx_r31 = ɵngcc0.ɵɵnextContext(2); return ctx_r31.open(_r22); });
    ɵngcc0.ɵɵelementStart(19, "label", 24);
    ɵngcc0.ɵɵtext(20);
    ɵngcc0.ɵɵpipe(21, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(22, "span", 34);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(23, AddressBookComponent_ng_container_0_div_18_ng_template_23_Template, 11, 9, "ng-template", null, 35, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r21 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(4, 6, "cl.address.book.mobile.table.full.name"));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(item_r21.FullName);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(10, 8, "cl.address.book.mobile.table.email"));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(item_r21.EmailAddress);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(17, 10, "cl.address.book.mobile.button.select"), " ");
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(21, 12, "address.remove.contact.screenreader"));
} }
function AddressBookComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, AddressBookComponent_ng_container_0_ng_container_1_Template, 21, 21, "ng-container", 2);
    ɵngcc0.ɵɵelementStart(2, "div", 3);
    ɵngcc0.ɵɵelementStart(3, "table", 4);
    ɵngcc0.ɵɵelementStart(4, "thead");
    ɵngcc0.ɵɵelementStart(5, "tr");
    ɵngcc0.ɵɵelementStart(6, "td", 5);
    ɵngcc0.ɵɵtext(7);
    ɵngcc0.ɵɵpipe(8, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(9, "td", 5);
    ɵngcc0.ɵɵtext(10);
    ɵngcc0.ɵɵpipe(11, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(12, "td", 6);
    ɵngcc0.ɵɵtemplate(13, AddressBookComponent_ng_container_0_div_13_Template, 4, 3, "div", 7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(14, "tbody");
    ɵngcc0.ɵɵtemplate(15, AddressBookComponent_ng_container_0_tr_15_Template, 17, 9, "tr", 8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(16, "div", 9);
    ɵngcc0.ɵɵelementStart(17, "div", 10);
    ɵngcc0.ɵɵtemplate(18, AddressBookComponent_ng_container_0_div_18_Template, 25, 14, "div", 11);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const addressBook_r3 = ctx.ngIf;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.addNew);
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(8, 6, "cl.address.book.table.full.name"));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(11, 8, "cl.address.book.table.email"));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.addNew);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", addressBook_r3);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngForOf", addressBook_r3);
} }
function AddressBookComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "fgbcl-loading");
} }
class AddressBookComponent {
    constructor(errorStateService, addressBookQuery, addressService, modalService) {
        this.errorStateService = errorStateService;
        this.addressBookQuery = addressBookQuery;
        this.addressService = addressService;
        this.modalService = modalService;
        this.addNew = false;
        this.selectedContact = new EventEmitter();
    }
    ngOnInit() {
        this.getAddressBookList();
    }
    getAddressBookList() {
        this.addressBook$ = this.addressBookQuery
            .selectAllContacts()
            .pipe(map((contactsList) => contactsList.sort((a, b) => a.FullName.localeCompare(b.FullName))));
    }
    selectContact(item) {
        this.selectedContact.emit(item);
    }
    showAddNewForm() {
        this.addNew = !this.addNew;
    }
    addContact() {
        this.addressService
            .add(this.fullName, this.email)
            .toPromise()
            .catch((error) => {
            this.errorStateService.addError(error);
            setTimeout(() => this.errorStateService.clearErrors(), 3000);
        });
    }
    removeContact(id) {
        this.addressService.remove(id).toPromise();
        this.modalService.dismissAll();
    }
    open(content) {
        this.modalService
            .open(content, {
            ariaLabelledBy: 'modal-basic-title',
            backdrop: 'static',
        })
            .result.then((result) => { }, (reason) => { });
    }
}
AddressBookComponent.ɵfac = function AddressBookComponent_Factory(t) { return new (t || AddressBookComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.ErrorStateService), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.AddressBookQuery), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.AddressBookService), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.NgbModal)); };
AddressBookComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: AddressBookComponent, selectors: [["fgbcl-address-book"]], outputs: { selectedContact: "selectedContact" }, decls: 4, vars: 4, consts: [[4, "ngIf", "ngIfElse"], ["loading", ""], [4, "ngIf"], [1, "d-none", "d-lg-block"], [1, "table", "address-book-table"], ["scope", "col", 1, "contact-management-table-row-text"], [1, "text-center"], ["class", "address-book-add-new-contact-button", 3, "click", 4, "ngIf"], [4, "ngFor", "ngForOf"], [1, "d-block", "d-lg-none"], [1, "card", "p-4"], ["class", "mt-3 mb-3", 4, "ngFor", "ngForOf"], [1, "form-group", "d-flex", "justify-content-between"], [1, "contact-management-table-cell"], ["type", "text", 1, "address-book-input", 3, "placeholder", "ngModel", "ngModelChange"], ["type", "email", 1, "address-book-input", 3, "placeholder", "ngModel", "ngModelChange"], [1, "d-flex", "address-book-button-div"], [1, "btn", "btn-primary", "address-book-add-button", 3, "disabled", "click"], [1, "btn", "btn-primary", "address-book-close-form-button", 3, "click"], [1, "icon-cancel-circle"], [1, "address-book-add-new-contact-button", 3, "click"], [1, "icon-plus-circle"], [1, "btn", "btn-primary", "address-book-select-button", 3, "click"], ["confirmModal", "", 1, "btn", "btn-primary", "address-book-delete-button", 3, "confirmContent", "confirm"], [1, "accessibility-only"], [1, "bg-primary", "text-white", "icon-trash"], ["confirmContent", ""], [1, "mt-3", "mb-3"], [1, "sub-title"], [1, "result-field"], [1, "row"], [1, "container", "mt-2", "mb-3"], [1, "col-3", "btn", "btn-success", "btn-remove-contact", 3, "click"], [1, "col-2", "offset-7", "btn", "btn-danger", "btn-remove-contact", 3, "click"], [1, "icon-trash"], ["confirmDelete", ""], [1, "modal-body"], ["body", "", 1, "text-center", "color-secondary", "p-3"], [1, "btn-container"], ["type", "button", 1, "btn", "btn-danger", 3, "click"], ["type", "button", 1, "btn", "btn-success", 3, "click"]], template: function AddressBookComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, AddressBookComponent_ng_container_0_Template, 19, 10, "ng-container", 0);
        ɵngcc0.ɵɵpipe(1, "async");
        ɵngcc0.ɵɵtemplate(2, AddressBookComponent_ng_template_2_Template, 1, 0, "ng-template", null, 1, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = ɵngcc0.ɵɵreference(3);
        ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(1, 2, ctx.addressBook$))("ngIfElse", _r1);
    } }, directives: [ɵngcc3.NgIf, ɵngcc3.NgForOf, ɵngcc4.DefaultValueAccessor, ɵngcc4.NgControlStatus, ɵngcc4.NgModel, ɵngcc5.ErrorsComponent, ɵngcc6.ConfirmModalDirective, ɵngcc7.LoadingComponent], pipes: [ɵngcc3.AsyncPipe, ɵngcc8.TranslatePipe], styles: [""] });
AddressBookComponent.ctorParameters = () => [
    { type: ErrorStateService },
    { type: AddressBookQuery },
    { type: AddressBookService },
    { type: NgbModal }
];
AddressBookComponent.propDecorators = {
    selectedContact: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AddressBookComponent, [{
        type: Component,
        args: [{
                selector: 'fgbcl-address-book',
                template: "<ng-container *ngIf=\"addressBook$ | async as addressBook; else loading\">\r\n  <ng-container *ngIf=\"addNew\">\r\n    <div class=\"form-group d-flex justify-content-between\">\r\n      <table class=\"table address-book-table\">\r\n        <tr>\r\n          <td class=\"contact-management-table-cell\">\r\n            <input\r\n              class=\"address-book-input\"\r\n              type=\"text\"\r\n              placeholder=\"{{ 'address.full.name.screenreader' | translate }}\"\r\n              [(ngModel)]=\"fullName\"\r\n              attr.aria-label=\"{{ 'address.full.name.screenreader' | translate }}\"\r\n            />\r\n          </td>\r\n          <td class=\"contact-management-table-cell\">\r\n            <input\r\n              class=\"address-book-input\"\r\n              type=\"email\"\r\n              placeholder=\"{{ 'address.email.screenreader' | translate }}\"\r\n              [(ngModel)]=\"email\"\r\n              attr.aria-label=\"{{ 'address.email.screenreader' | translate }}\"\r\n            />\r\n          </td>\r\n          <td>\r\n            <div class=\"d-flex address-book-button-div\">\r\n              <button class=\"btn btn-primary address-book-add-button\" [disabled]=\"!fullName || !email\" (click)=\"addContact()\">\r\n                {{ 'cl.address.book.add.button' | translate }}\r\n              </button>\r\n              <button\r\n                class=\"btn btn-primary address-book-close-form-button\"\r\n                (click)=\"showAddNewForm()\"\r\n                attr.aria-label=\"{{ 'address.close.screenreader' | translate }}\"\r\n              >\r\n                <span class=\"icon-cancel-circle\"></span>\r\n              </button>\r\n            </div>\r\n          </td>\r\n        </tr>\r\n      </table>\r\n    </div>\r\n    <fgbcl-errors></fgbcl-errors>\r\n  </ng-container>\r\n  <div class=\"d-none d-lg-block\">\r\n    <table class=\"table address-book-table\">\r\n      <thead>\r\n        <tr>\r\n          <td scope=\"col\" class=\"contact-management-table-row-text\">{{ 'cl.address.book.table.full.name' | translate }}</td>\r\n          <td scope=\"col\" class=\"contact-management-table-row-text\">{{ 'cl.address.book.table.email' | translate }}</td>\r\n          <td class=\"text-center\">\r\n            <div (click)=\"showAddNewForm()\" *ngIf=\"!addNew\" class=\"address-book-add-new-contact-button\">\r\n              <span class=\"icon-plus-circle\"></span>\r\n              {{ 'cl.address.book.add.contact' | translate }}\r\n            </div>\r\n          </td>\r\n        </tr>\r\n      </thead>\r\n      <tbody>\r\n        <tr *ngFor=\"let item of addressBook\">\r\n          <td class=\"contact-management-table-cell\">{{ item.FullName }}</td>\r\n          <td class=\"contact-management-table-cell\">{{ item.EmailAddress }}</td>\r\n          <td>\r\n            <div class=\"d-flex address-book-button-div\">\r\n              <button (click)=\"selectContact(item)\" class=\"btn btn-primary address-book-select-button\">\r\n                {{ 'cl.address.book.button.select' | translate }}\r\n              </button>\r\n              <button\r\n                class=\"btn btn-primary address-book-delete-button\"\r\n                confirmModal\r\n                [confirmContent]=\"confirmContent\"\r\n                (confirm)=\"removeContact(item.Id)\"\r\n              >\r\n                <label class=\"accessibility-only\">{{ 'address.remove.contact.screenreader' | translate }}</label>\r\n                <span class=\"bg-primary text-white icon-trash\"></span>\r\n              </button>\r\n              <ng-template #confirmContent>{{ 'cl.address.book.delete.confirm.text' | translate }}</ng-template>\r\n            </div>\r\n          </td>\r\n        </tr>\r\n      </tbody>\r\n    </table>\r\n  </div>\r\n  <div class=\"d-block d-lg-none\">\r\n    <div class=\"card p-4\">\r\n      <div class=\"mt-3 mb-3\" *ngFor=\"let item of addressBook\">\r\n        <div>\r\n          <div class=\"sub-title\">{{ 'cl.address.book.mobile.table.full.name' | translate }}</div>\r\n          <div class=\"result-field\">{{ item.FullName }}</div>\r\n        </div>\r\n        <div>\r\n          <div class=\"sub-title\">{{ 'cl.address.book.mobile.table.email' | translate }}</div>\r\n          <div class=\"result-field\">{{ item.EmailAddress }}</div>\r\n        </div>\r\n        <div class=\"row\">\r\n          <div class=\"container mt-2 mb-3\">\r\n            <button (click)=\"selectContact(item)\" class=\"col-3 btn btn-success btn-remove-contact\">\r\n              {{ 'cl.address.book.mobile.button.select' | translate }}\r\n            </button>\r\n            <button (click)=\"open(confirmDelete)\" class=\"col-2 offset-7 btn btn-danger btn-remove-contact\">\r\n              <label class=\"accessibility-only\">{{ 'address.remove.contact.screenreader' | translate }}</label>\r\n              <span class=\"icon-trash\"></span>\r\n            </button>\r\n          </div>\r\n        </div>\r\n        <!-- Confirm Delete Modal -->\r\n        <ng-template #confirmDelete let-modal>\r\n          <div class=\"modal-body\">\r\n            <div body class=\"text-center color-secondary p-3\">{{ 'cl.address.book.mobile.delete.confirm.text' | translate }}</div>\r\n            <div class=\"btn-container\">\r\n              <button type=\"button\" class=\"btn btn-danger\" (click)=\"modal.close('Close click')\">\r\n                {{ 'cl.address.book.mobile.button.cancel' | translate }}\r\n              </button>\r\n              <button type=\"button\" class=\"btn btn-success\" (click)=\"removeContact(item.Id)\">\r\n                {{ 'cl.address.book.mobile.button.confirm' | translate }}\r\n              </button>\r\n            </div>\r\n          </div>\r\n        </ng-template>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</ng-container>\r\n<ng-template #loading>\r\n  <fgbcl-loading></fgbcl-loading>\r\n</ng-template>\r\n",
                styles: [""]
            }]
    }], function () { return [{ type: ɵngcc1.ErrorStateService }, { type: ɵngcc1.AddressBookQuery }, { type: ɵngcc1.AddressBookService }, { type: ɵngcc2.NgbModal }]; }, { selectedContact: [{
            type: Output
        }] }); })();

class AddressBookModule {
}
AddressBookModule.ɵfac = function AddressBookModule_Factory(t) { return new (t || AddressBookModule)(); };
AddressBookModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: AddressBookModule });
AddressBookModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            ErrorsModule,
            LoadingModule,
            FormsModule,
            ConfirmModalModule,
            TranslateModule.forRoot({
                loader: {
                    provide: TranslateLoader,
                    useClass: FGBTranslationLoader,
                    deps: [HttpClient]
                },
                missingTranslationHandler: {
                    provide: MissingTranslationHandler,
                    useClass: FGBMissingTranslationHandler
                }
            }),
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(AddressBookModule, { declarations: function () { return [AddressBookComponent]; }, imports: function () { return [CommonModule,
        ErrorsModule,
        LoadingModule,
        FormsModule,
        ConfirmModalModule, ɵngcc8.TranslateModule]; }, exports: function () { return [AddressBookComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AddressBookModule, [{
        type: NgModule,
        args: [{
                declarations: [AddressBookComponent],
                imports: [
                    CommonModule,
                    ErrorsModule,
                    LoadingModule,
                    FormsModule,
                    ConfirmModalModule,
                    TranslateModule.forRoot({
                        loader: {
                            provide: TranslateLoader,
                            useClass: FGBTranslationLoader,
                            deps: [HttpClient]
                        },
                        missingTranslationHandler: {
                            provide: MissingTranslationHandler,
                            useClass: FGBMissingTranslationHandler
                        }
                    }),
                ],
                exports: [AddressBookComponent]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { AddressBookComponent, AddressBookModule };

//# sourceMappingURL=fgb-portal-component-library-src-lib-user-address-book.js.map